module.exports = __webpack_public_path__ + "static/media/pf19.bb6bcf18.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/pf19.png
// module id = 2659
// module chunks = 0